import { render, staticRenderFns } from "./StudentInformationAlertComponent.vue?vue&type=template&id=4bb945fe"
import script from "./StudentInformationAlertComponent.vue?vue&type=script&lang=js"
export * from "./StudentInformationAlertComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports